import { IList } from 'app/services/api5-service/api.interface';

import { ListProps } from '../model';

/**
 * Get list displaying type from BE meta
 *
 * @param control
 */
export function getListType(control: IList): ListProps['type'] {
  if (!control.$type) {
    return 'list';
  }
  return control.$type;
}
